'use strict';
(function (window, document, $) {
    var $formElement = $('#jwsdw-contactUs-form'),
        $dropdownElement = $('#jwsdw-contactUs-question'),
        $allData = $('#jwsdw-contact-allData'),
        $options = $('.jwsdw-contactUs-deleteData'),
        $checkboxWhatsapp = $('#jwsdw-contact-whatsapp'),
        $checkboxSMS = $('#jwsdw-contact-sms'),
        $phone = $('#jwsdw-contactUs-phone'),
        xhr;

    $.validator.setDefaults({
        'rules': {
            'email': {
                'invalidvalue': true,
                'customemail': true
            },
            'allData': {
                'requiredCheckboxGroup': $options
            }
        }
    });

    // initialize form validation
    $formElement.validate();

    $formElement.on('submit', function(e) {
        var $form = this,
            $contactUsForm = $(this),
            $captcha = $contactUsForm.find('.g-recaptcha'),
            $submitButton = $contactUsForm.find('.jws-buttonYellow');

        e.preventDefault();

        // only submit form if frontend validation is successful and no other call is executed
        if (!$contactUsForm.valid() || (xhr && xhr.readyState !== 4)) {
            return;
        }

        if (window.jwsdwRecaptchaSettings.captchaDisabled === false) {
            if (!window.grecaptcha || window.jwsdwUtil.captcha.getResponse($captcha.attr('id')).length !== 0) {
                return;
            }
            window.jwsdwUtil.captcha.execute($captcha.attr('id')).then(submitFormHandler);
        } else {
            submitFormHandler();
        }

        /**
         * Method generate settings object for ajax requests
         * @param {String|object} form selector element to pass to jQuery
         * @returns {Object} ajax paremeters
         */
        function asURLEncoded(form) {
            form = $(form);
            return {
                'contentType': 'application/x-www-form-urlencoded; charset=UTF-8',
                'type': form.attr('method'),
                'url': form.attr('action'),
                'data': form.serialize(),
                'dataType': 'json'
            };
        }

        /**
         * @description Method to trigger submit again when form is valid
         * @returns {void}
         */
        function submitFormHandler() {
            var $err = $contactUsForm.find('.jwsdw-contactUs-error'),
                $message = $contactUsForm.find('.jwsdw-contactUs-success');

            if (window.jwsdwRecaptchaSettings.captchaDisabled === false && window.jwsdwUtil.captcha.getResponse($captcha.attr('id')).length === 0) {
                // no response yet, check again in 200ms
                setTimeout(submitFormHandler, 200);
                return;
            }

            $submitButton.find('.jwsdw-buttonText').addClass('jwsdw-invisible');
            $submitButton.find('.jwsdw-spinner').removeClass('jws-hidden');
            $submitButton.attr('disabled', 'disabled');

            xhr = $.ajax(asURLEncoded($form)).done(function(response) {
                if (response.success) {
                    $formElement[0].reset();
                    $formElement.find('#jwsdw-contactUs-question').val('');
                    $contactUsForm.find('.jwsdw-formLabelValid').removeClass('jwsdw-formLabelValid');
                    $err.addClass('jws-hidden');
                    $message.removeClass('jws-hidden');

                    window.jwsdwApi.tracking.fireEvent('contactUs', {
                        'type': 'contactUs'
                    });

                    window.dataLayer.push({
                        'event':'ce.contact',
                        'eventCategory':'Contact',
                        'eventAction':'Form',
                        'eventLabel': undefined,
                        'eventValue': undefined,
                        'nonInteraction': false
                    });
                }
            }).fail(function(response) {
                $message.addClass('jws-hidden');
                $err.text(response.responseJSON.details.message).removeClass('jws-hidden');
            }).always(function() {
                if (window.jwsdwRecaptchaSettings.captchaDisabled === false) {
                    window.grecaptcha.reset(window.jwsdwRecaptcha[$captcha.attr('id')]);
                }
                $submitButton.find('.jwsdw-buttonText').removeClass('jwsdw-invisible');
                $submitButton.find('.jwsdw-spinner').addClass('jws-hidden');
                $submitButton.removeAttr('disabled');
            });
        }
    });

    // show delete data checkboxes if dropdown option is selected
    $dropdownElement.on('change', function () {
        $('#jwsdw-deleteData').toggleClass('jws-hidden', $(this).val() !== 'contactUsDeleteMyData');
    });

    // select all checkboxes
    $allData.on('change', function () {
        $options.prop('checked', $(this).prop('checked')).trigger('change');
        $allData.valid();
    });

    // update checkboxes
    $options.on('change', updateCheckboxGroup);

    // toggle required phone field
    $checkboxWhatsapp.on('change', toggleRequiredPhone);

    // toggle required phone field
    $checkboxSMS.on('change', toggleRequiredPhone);

    /**
     * Method to set phone field as required/optional
     * @returns {void}
     */
    function toggleRequiredPhone() {
        $('.jwsdw-phone-optional').toggleClass('jws-hidden', $(this).prop('checked'));
        $phone.prop('required', $(this).prop('checked'));
    }

    /**
     * Method to update checkbox group states
     * @returns {void}
     */
    function updateCheckboxGroup() {
        let checkedCount = 0;

        $options.each(function() {
            if ($(this).prop('checked')) {
                checkedCount++;
            }
        });

        if (checkedCount === 0) {
            $allData.prop({
                'indeterminate': false,
                'checked': false
            });
        } else if (checkedCount === $options.length) {
            $allData.prop({
                'indeterminate': false,
                'checked': true
            });
        } else {
            $allData.prop({
                'indeterminate': true,
                'checked': false
            });
        }

        $allData.valid();
    }

}(window, document, jQuery));
